import api from "./api";

export const getCategories = (page) => {
    return api.get("admin/Category", {
      params: {
        page: page,
        limit: 10,
      },
    });
  };
export const createCategory = (name, internationalizationLanguage) => {
  return api.post(`admin/categories`, { name, internationalizationLanguage });
};

export const deleteCategory = (id) => {
    return api.delete(`admin/categories/${id}`);
};

export const updateCategory = (id, name, internationalizationLanguage) => {
    return api.put(`admin/categories/${id}`, { name, internationalizationLanguage });
}

export const getCategoriesBySearch = (searchItem, search) => {
    return api.get(`admin/Category?searchItem=${searchItem}&search=${search}`);
};
      
export const getCategoriesByOrder = (item, direction) => {
    return api.get(`admin/Category?order=${item}&direction=${direction}`);
};